// src/components/nutrition/nutritionConfig.js

/**
 * Minimum number of logged days required for meaningful trend analysis
 * in nutrition reports. Below this threshold, the system will show a
 * limited summary encouraging more data collection.
 */
export const MINIMUM_LOGGED_DAYS_FOR_TREND_ANALYSIS = 10;
